(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 768;

  function getPageFlipClass() {
    return window.St && window.St.PageFlip;
  }

  class LtcoFlipbook extends HTMLElement {
    constructor() {
      super();
      this._pageFlip = null;
      this._autoFlipTimer = null;
      this._ro = null;
      this._isMobile = false;
      this._lastWidth = 0;
    }

    connectedCallback() {
      if (!getPageFlipClass()) {
        requestAnimationFrame(() => this._init());
      } else {
        this._init();
      }
    }

    disconnectedCallback() {
      this._destroy();
    }

    _init() {
      const PageFlip = getPageFlipClass();
      if (!PageFlip) return;

      this._stage = this.querySelector('.ltco-flipbook__stage');
      this._prevBtn = this.querySelector('.ltco-flipbook__btn--prev');
      this._nextBtn = this.querySelector('.ltco-flipbook__btn--next');
      this._currentEl = this.querySelector('.ltco-flipbook__current');

      this._isMobile = window.innerWidth < MOBILE_BREAKPOINT;

      // Use the actual rendered width of the stage so the book always fits
      const stageWidth = this._stage.offsetWidth;
      this._lastWidth = stageWidth;

      // In spread mode each page = half the stage; in single mode = full stage
      const pageWidth = this._isMobile ? stageWidth : Math.floor(stageWidth / 2);

      // Height: fixed px, adapt by first image ratio, or adapt by selected ratio
      const heightMode = this.dataset.heightMode || 'adapt_image_first';
      const fixedHeight = parseInt(this.dataset.fixedHeight, 10) || 560;
      const aspectRatio = parseFloat(this.dataset.aspectRatio) || 1.414;
      const firstImageRatio = parseFloat(this.dataset.firstImageRatio) || 1.414;
      let height;
      if (heightMode === 'fixed') {
        height = fixedHeight;
      } else if (heightMode === 'adapt_image_first') {
        height = Math.round(pageWidth * firstImageRatio);
      } else {
        height = Math.round(pageWidth * aspectRatio);
      }

      // Apply height to stage so it matches StPageFlip's canvas
      this._stage.style.height = height + 'px';

      this._pageFlip = new PageFlip(this._stage, {
        width: pageWidth,
        height,
        size: 'fixed',
        drawShadow: true,
        flippingTime: 700,
        usePortrait: true,
        autoSize: true,
        mobileScrollSupport: true,
        useMouseEvents: true,
        startPage: parseInt(this.dataset.startPage, 10) || 0,
        showCover: true,
        disableFlipByClick: false,
        swipeDistance: 30,
        showPageCorners: true,
        singlePage: this._isMobile,
      });

      this._pageFlip.loadFromHTML(
        this._stage.querySelectorAll('.ltco-flipbook__page')
      );

      this._pageFlip.on('flip', (e) => {
        if (this._currentEl) this._currentEl.textContent = e.data + 1;
      });

      this._prevBtn?.addEventListener('click', () => this._pageFlip.flipPrev());
      this._nextBtn?.addEventListener('click', () => this._pageFlip.flipNext());

      if (this.dataset.autoFlip === 'true') {
        const interval = (parseInt(this.dataset.autoFlipDuration, 10) || 5) * 1000;
        this._autoFlipTimer = setInterval(() => {
          const last = this._pageFlip.getCurrentPageIndex() >= this._pageFlip.getPageCount() - 1;
          last ? this._pageFlip.flip(0) : this._pageFlip.flipNext();
        }, interval);
      }

      // Reinitialize whenever the stage width changes (breakpoint crossing or container resize)
      this._ro = new ResizeObserver(() => {
        const newWidth = this._stage.offsetWidth;
        const nowMobile = window.innerWidth < MOBILE_BREAKPOINT;
        if (newWidth !== this._lastWidth || nowMobile !== this._isMobile) {
          this._destroy();
          this._init();
        }
      });
      this._ro.observe(this._stage);
    }

    _destroy() {
      clearInterval(this._autoFlipTimer);
      this._autoFlipTimer = null;
      this._ro?.disconnect();
      this._ro = null;
      try { this._pageFlip?.destroy(); } catch (_) {}
      this._pageFlip = null;
    }
  }

  customElements.define('ltco-flipbook', LtcoFlipbook);

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelector('ltco-flipbook')?.connectedCallback();
    });
    document.addEventListener('shopify:section:unload', (e) => {
      e.target.querySelector('ltco-flipbook')?._destroy();
    });
    document.addEventListener('shopify:block:select', (e) => {
      const fb = e.target.closest('ltco-flipbook');
      if (!fb?._pageFlip) return;
      const idx = [...fb.querySelectorAll('.ltco-flipbook__page')].indexOf(e.target);
      if (idx >= 0) fb._pageFlip.flip(idx);
    });
  }
})();
